module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('product-status', {
    attrs: {
      "module": _vm.module
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Agrupador(es) do(s) produto(s)"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.productIds),
      expression: "filters.productIds"
    }],
    staticClass: "form-textarea",
    attrs: {
      "rows": "8",
      "placeholder": "997, 998, 999, 1000"
    },
    domProps: {
      "value": (_vm.filters.productIds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "productIds", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplos agrupadores.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "SKU(s) do(s) produto(s)"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.skus),
      expression: "filters.skus"
    }],
    staticClass: "form-textarea",
    attrs: {
      "rows": "8",
      "placeholder": "SKU123, SKU456, SKU789"
    },
    domProps: {
      "value": (_vm.filters.skus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "skus", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplos SKUs.")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a0e732b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/removeProduct/filters/marketplace/Sicoob.vue
// module id = 3062
// module chunks = 0